import { downLoadFile, get, post, put } from 'service/xhr/fetch'
import { URL_PREFIX } from 'utils/constant'

export const REPORT = (data: any) => post(`/${URL_PREFIX}/pdt-report/add`, data)

export const GET_MY_REPORT_PAGE_LIST = (data: any) => {
  return get(`/${URL_PREFIX}/pdt-report/page-list`, data)
}

export const GET_REPORT_LIST = (data: any) => {
  return get(`/${URL_PREFIX}/report/page-list`, data)
}

export const EXPORT_MY_REPORT_LIST = (data: any) => {
  return downLoadFile(`/${URL_PREFIX}/pdt-report/list-export`, data)
}

export const EXPORT_REPORT_LIST = (data: any) => {
  return downLoadFile(`/${URL_PREFIX}/report/opt/list-export`, data)
}

export const UPDATE_REPORT = (data: any) => {
  return post(`/${URL_PREFIX}/report/update`, data)
}
export const DEAL_REPORT = (reportId: string) => {
  return put(`/${URL_PREFIX}/report/deal/${reportId}`)
}
